<template>
  <el-autocomplete
    ref="product"
    placeholder="Buscar producto..."
    v-model="productSearch.code"
    :fetch-suggestions="querySearchAsync"
    @select="handleSelect"
    @clear="clear"
    :trigger-on-focus="false"
    clearable
    size="normal"
    class="w-100"
  >
    <template slot="suffix">
      <el-button @click="addProduct" class="mt-5" icon="el-icon-plus" size="mini" plain circle></el-button>
    </template>
    <template slot-scope="{ item }">
      <div class style="line-height: 1; padding: 5px 0 5px">
        <i class="mdi mdi-barcode"></i>
        {{ item.codigo }}
        <br/>
        {{ item.descripcion }}
      </div>
    </template>
  </el-autocomplete>
</template>

<script>
import { mapMutations } from "vuex";
import { search } from "@/api/product"
export default {
  data(){
    return {
      productSearch: {
        id: (this.default) ? this.default.id : null,
        code: (this.default) ? this.default.codigo : null,
        description: (this.default) ? this.default.description : null,
      }
    }
  },
  props:['default'],
  watch: {
    default: function (val) {
      if(val)
        this.productSearch = {
          id: val.id,
          code: val.codigo,
          description: val.descripcion,
        }     
    }
  },
  methods: {
    ...mapMutations(['setRightMenu']),
    addProduct(){
      this.setRightMenu({
        componentActive: 'product-form-component',
        drawer: true,
        data: {
          icon: 'package-variant',
          title: 'Agregar producto',
          btnRemove: false,
          field_id: null,
          hidden_btn: true,
          edit: false,
        }
      })
    },
    querySearchAsync(queryString, cb) {
      if (queryString && queryString.length > 2) {
        search(queryString)
          .then(({ data }) => {
            cb(data.data);
          })
          .catch((error) => {
            this.$message.error('Error al buscar producto')
            console.error(error);
          });
      }
    },
    handleSelect(item) {
      this.productSearch = {
        id: item.id,
        code: item.codigo,
        description: item.descripcion
      }
      this.$emit('select', item)
    },
    clear() {
      console.log('entró');
      this.$emit('clear', null)
    },
    reset(){
      this.productSearch = {
        id: null,
        code: null,
        description: null
      }
    }
  },
}
</script>